import type { SerializedMeterAddon } from '@enmon/commons/lib/tools';
import { Input } from 'antd';
import type { DescriptionsColumn } from 'components/enmon/descriptions/Descriptions';
import { OutputTechnologiesSelect } from 'components/form/select/OutputTechnologySelect';
import type { MeterModuleFormValues } from '../types';

export const getMeterModuleDescriptionColumns = (): DescriptionsColumn<MeterModuleFormValues>[] => [
  {
    name: 'name',
    label: 'Name',
    required: true,
    editable: true,
    formItemProps: { required: true, rules: [{ required: true, message: 'Name is required' }] },
    editContent: <Input placeholder="Name" />,
    render: (module: SerializedMeterAddon) => module.name,
  },
  {
    name: 'technology',
    label: 'Technology',
    editable: true,
    required: true,
    formItemProps: { required: true, rules: [{ required: true, message: 'Technology is required' }] },
    editContent: <OutputTechnologiesSelect allowClear={false} placeholder="Select technology" />,
    render: (module: SerializedMeterAddon) => module.technology,
  },
  {
    name: 'internal_note',
    label: 'Internal note',
    editable: true,
    editContent: (
      <Input.TextArea
        allowClear
        placeholder="White on the pin to the left and green in the right hole... Note on INT3 and 4 the scheme is reversed..."
        rows={6}
      />
    ),
    render: (module: SerializedMeterAddon) => module.internal_note,
  },
];
